import React, { useState } from 'react';

import Menu from './Menu';
import NavLink from './NavLink';

function Sidebar() {
    const [burgerOpen, setBurgerOpen] = useState("false");
    const burgerToggle = (e) => {
            e.preventDefault();
            setBurgerOpen(!burgerOpen);
    };

    return (
        <div>
            <div id="nav-icon3" className={burgerOpen ? "" : "open"} onClick={burgerToggle}>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <Menu burgerOpen={burgerOpen}>
                <NavLink to="/hello" label="Hello" />
                <NavLink to="/columbus" label="Columbus" />
                {/* <NavLink to="/columbus-dla-biznesu" label="Dla&nbsp;Biznesu" /> */}
                {/* <NavLink to="/columbus-obrot" label="Obrót" /> */}
                <NavLink to="/siec-agencyjna" label="Columbus Partner" />
                <NavLink to="/hr" label="HR" />
                <NavLink to="/one" label="One" />
                <NavLink to="/zenera" label="Zenera" />
                <NavLink to="/prime" label="Prime" />
                {/* <NavLink to="/sieci-partnerskie" label="Sieci Partnerskie" /> */}
            </Menu>
        </div>
    );
}

export default Sidebar;